<template>

  <div class="pb">
 
    <div class="headerow"> 
      <h1>
        Strain Categories   
      </h1>           
    </div>


   
    <div 
      class="products strains_items"
    >

      <GeneralStrainCategory
        v-for="(item) in RPreferredStrainPageCategories"     
        :icon="categoryImg(item)"
        :link="categoryLink(item)"
        :name="categoryName(item)"
        :description="categoryShort(item)"
      />


    </div>
 

 
 
  </div>

</template>

<script setup lang="ts"> 
 

import { TagsStrains2, getTagsKeys, getTagsSimple } from '@/types/other'
import type { Strain } from '@/types/strain'
import type { Tag } from '@/types/other'
import { EStrainsFilters, RStrainCategoriesLinks, RStrainCategoriesImages, RPreferredStrainPageCategories } from '@/types/strain'
import {strains} from '~/i18n/strains/en.js'
import { useIntersectionObserver } from '@vueuse/core'
import { watchArray } from '@vueuse/core'


const route = useRoute();
const isEnded = ref(false)
const {$api, $adv, $ga, $patcher} = useNuxtApp()
 

const start = ref(0)
const limit = ref(40)
 
const categories = computed(() => {
  // exclude 'all:all'
  return Object.keys(RStrainCategoriesLinks).filter((item) => item !== 'all:all')
})

const categoryName = ((id: string) => {
  let el = strains?.find(item => item.id == id);
  return el?.name ?? '';
})

const categoryH1 = ((id: string) => {
  let el = strains?.find(item => item.id == id);
  return el?.h1 ?? '';
})

const categoryImg = ((id: string) => {
  return RStrainCategoriesImages[id] ?? null;
})

const categoryShort = ((id: string) => {
  let el = strains?.find(item => item.id == id);
  return el?.short??''
})

const categoryDescription = ((id: string) => {
  let el = strains?.find(item => item.id == id);
  return el?.description??''
})

const categoryLink = ((id: string) => {
  return RStrainCategoriesLinks[id] ?? null;
})


useHead(useNuxtApp().$head.getStrains());


 

</script>

<style scoped>

.products{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;
  margin-top: 1rem;
}
h1{
  margin-right: auto;
}
 
@container pb (max-width: 700px) {
   
}

 
</style>
